import { AssetModel, BalanceModel, listModelFactory, WalletModel, WalletOptionModel } from '@/models';
import WebWalletsClient from '@/network/wallet';
import type { Rate } from '@/types';
import Decimal from 'decimal.js';

export default {
    renameWallet(assetId: string, walletAddress: string, walletName: string) {
        return WebWalletsClient.renameWallet(assetId, walletAddress, walletName);
    },
    listWallets() {
        return WebWalletsClient.listWallets()
            .then(listModelFactory(WalletModel));
    },
    listAssets() {
        return WebWalletsClient.listAssets()
            .then(listModelFactory(AssetModel));
    },
    walletWithBalanceOptionsModelFactory(wallets: WalletModel[], assets: AssetModel[], rates: Rate[], defaultOptionName: string) {
        return wallets.reduce((result, wallet) => {
            const asset = assets.find(asset => asset.code === wallet.assetId);
            if (!asset) {
                return result;
            }
            const rate = rates.find(rate => rate.base === asset.currency) ?? null;
            if (!rate) {
                return result;
            }
            const fiatBalance = new BalanceModel({
                amount: new Decimal(wallet.balance.amount).times(rate.rate).toString(),
                currency: rate.quote,
            });

            result.push(new WalletOptionModel(wallet, asset, fiatBalance, defaultOptionName));
            return result;
        }, [] as WalletOptionModel[]);
    },
};
